import * as React from "react";
const Tiktok = props => <symbol viewBox="0 0 24 24" {...props}>
    <path fillRule="evenodd" d="M15.907 2c.33 2.838 1.914 4.53 4.669 4.71V9.9a7.3 7.3 0 01-4.621-1.35v5.97c0 7.585-8.268 9.955-11.592 4.519-2.136-3.5-.828-9.637 6.024-9.883v3.366a9.911 9.911 0 00-1.59.39A2.714 2.714 0 006.649 16.1c.462 3.265 6.45 4.231 5.952-2.148V2.006h3.306z" clipRule="evenodd" />
  </symbol>;
export default Tiktok;